// extracted by mini-css-extract-plugin
export default {"mainContainer":"PaintModule_mainContainer__9cKyt","canvasHolder":"PaintModule_canvasHolder__ie6Ga","svg":"PaintModule_svg__0+hU0"};